/**
 * Products section — mounts the Three.js 3D showcase + the card grid below.
 */
import { PRODUCTS } from '../config'
import { createIceButton } from '../ui/iceButton'
import { showToast } from '../ui/toast'
import { mountProductScene } from '../three/productScene'

export function mountProducts(): void {
  // ── 3D showcase ──
  const canvas3d = document.getElementById('products-3d-canvas') as HTMLCanvasElement | null
  if (canvas3d) {
    try {
      mountProductScene(canvas3d)
    } catch (err) {
      console.warn('[products] 3D scene failed to mount:', err)
    }
  }

  // ── Card list ──
  const grid = document.getElementById('products-grid') as HTMLDivElement | null
  if (!grid) return

  grid.innerHTML = ''

  PRODUCTS.forEach((p, idx) => {
    const card = document.createElement('article')
    card.className = 'product-card'
    card.setAttribute('data-reveal', 'up')
    card.setAttribute('data-reveal-delay', String(idx * 0.1))

    const imageWrap = document.createElement('div')
    imageWrap.className = 'product-card__image-wrap'

    if (p.badge) {
      const badge = document.createElement('span')
      badge.className = 'product-card__badge'
      badge.textContent = p.badge
      imageWrap.appendChild(badge)
    }

    const img = document.createElement('img')
    img.className = 'product-card__image'
    img.src = p.img
    img.alt = p.name
    img.loading = 'lazy'
    img.decoding = 'async'
    imageWrap.appendChild(img)

    const head = document.createElement('div')
    head.className = 'product-card__head'
    const name = document.createElement('h3')
    name.className = 'product-card__name'
    name.textContent = p.name
    const arrow = document.createElement('span')
    arrow.className = 'product-card__arrow'
    arrow.textContent = '↗'
    head.append(name, arrow)

    const desc = document.createElement('p')
    desc.className = 'product-card__desc'
    desc.textContent = p.desc

    const price = document.createElement('div')
    price.className = 'product-card__price'
    price.innerHTML = `<small>a partir de</small> ${p.price.replace('A partir de ', '')}`

    const cta = createIceButton({
      label: 'Pedir agora',
      size: 'small',
      onClick: () => {
        document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        const msgField = document.getElementById('contact-message') as HTMLTextAreaElement | null
        if (msgField && !msgField.value.trim()) {
          msgField.value = `Olá! Gostaria de pedir o produto "${p.name}".`
          const counter = document.getElementById('contact-counter')
          if (counter) counter.textContent = `${msgField.value.length} / 1000`
        }
        showToast(`${p.name} adicionado ao formulário`, 'ok', 3000)
      },
    })

    // Click anywhere on card also goes to contact
    card.addEventListener('click', (e) => {
      // Don't double-trigger if they clicked the button
      if ((e.target as HTMLElement).closest('.ice-button')) return
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })

    card.append(imageWrap, head, desc, price, cta)
    grid.appendChild(card)
  })
}
